export enum PATHS {
  LOGIN = '/login',
  EMPLOYEES = '/',
  NEWSFEED = '/newsfeed',

  PRODUCTS_PAGE = '/products/pages/[page]',
  PRODUCTS_DETAIL = '/products/[name]',
  PRODUCTS_SEARCH = '/products/search',

  ADMIN = '/admin',
  ADMIN_COMPANIES = '/admin/companies',
  ADMIN_EMPLOYEES = '/admin/employees',

  VERIFY = '/email/verify',

  ONBOARDING_WELCOME = '/onboarding/welcome',
  ONBOARDING_INTRO = '/onboarding/intro',
  ONBOARDING_AOS = '/onboarding/area-of-specialization',
  ONBOARDING_PRODUCT_GROUPS = '/onboarding/product-groups',
  ONBOARDING_CLINICAL_AREA_DETAILS = '/onboarding/clinical-area-details',
  ONBOARDING_SUCCESS = '/onboarding/success',
}

export const REST_API_PATHS = {
  newsFeedItemImageUpload: 'newsitemimage/upload',
  companyLogoUpload: 'uploadImage',
};
